
export const portalBasicApi = "/portalbasicapi"
export const portalBiApi = "/portalbiapi"
export const earlyWarningApi = "/earlywarningapi"
export const schedulerApi = "/schedulerapi"
export const licenseApi = "/licenseapi"
export const weChatApi = "/wechatapi"
export const dingTalkApi = "/dingtalkapi"
export const aiApi = "/aiapi"
export const earthLogApi = "/earthlogapi"
export const portalDataCollectionApi = "/portaldatacollectionapi"
export const authorize = "/authorize"
export const workflowApi = "/workflowapi"